import request from '@/shared/api/request';

export const createKubernetesPool = (
  uuid: string,
  data: {
    name: string;
    size: string;
    count: number;
  },
): Promise<unknown> =>
  request({
    url: `/kubernetes/${uuid}/node_pools/`,
    method: 'POST',
    data,
  });
